import { Fragment, ReactNode } from "react";
import styled from "styled-components";

type FieldCheckBoxGroupProps = {
  children: ReactNode;
};

const FieldCheckBoxGroupWrapper = styled.div``;

const FieldCheckBoxGroup = ({ children }: FieldCheckBoxGroupProps) => {
  return (
    <>
      <FieldCheckBoxGroupWrapper>{children}</FieldCheckBoxGroupWrapper>
    </>
  );
};

export default FieldCheckBoxGroup;
